import React from "react";
import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import * as widgets from "widgets/register";

export const VIEW_FIELDS = {
  "/Public/BlogCollection": {
    fields: ["collectionId", "title", "description", "postIds", "createdAt", "updatedAt"],
  },
};

export const Sidebar = () => null;
export const Indice = () => null;

export const Content = () => {
  const { values, schema, base } = useSectionContext();

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <div className="float-right">
            <Link className="btn btn-primary" to={`${base}/edit`}>
              Edit
            </Link>{" "}
            <Link className="btn btn-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Fields
            schema={schema}
            values={values}
            widgets={widgets}
            target={{ $ref: "/Public/BlogCollection" }}
            config={VIEW_FIELDS}
          />
        </Col>
      </Row>
    </Container>
  );
};
